import styled from "styled-components";

export const MainTemplates = styled.div`
  display: grid;
  width: 100vw;
  height: 100vh;
  grid-template-areas:
    "HD"
    "CT";
  grid-template-rows: 56px auto;
  background: ${(props) => props.theme.colors.mainBg};
`;

export const ContentsSection = styled.section`
  grid-area: CT;
  overflow-y: auto;
  display: flex;
  padding: 0 27px;
  flex-direction: column;
  gap: 40px;
`;
